module.exports = __webpack_public_path__ + "static/media/burger.529fa584.svg";